var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2366 17.4627L14.63 18.856L17.4166 16.0693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1468 9.96482C11.0552 9.95565 10.9452 9.95565 10.8443 9.96482C8.66266 9.89148 6.93016 8.10398 6.93016 5.90398C6.921 3.65815 8.74516 1.83398 10.991 1.83398C13.2368 1.83398 15.061 3.65815 15.061 5.90398C15.061 8.10398 13.3193 9.89148 11.1468 9.96482Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9907 19.9929C9.3224 19.9929 7.66323 19.5712 6.39823 18.7279C4.1799 17.2429 4.1799 14.8229 6.39823 13.347C8.91907 11.6604 13.0532 11.6604 15.5741 13.347",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9ce4ad5b458059e6a953f4fbf3fd0323.svg";
export { ForwardRef as ReactComponent };